import { render, staticRenderFns } from "./_manage-channel.vue?vue&type=template&id=25a62484"
import script from "./_manage-channel.vue?vue&type=script&lang=js"
export * from "./_manage-channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports